<template>
  <div>
    <v-menu
      offset-y
      close-on-content-click
      content-class="qmkey-toolbar-menu-contents elevation-1"
      dense
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          icon
          :small="small"
          :medium="!small && !large"
          :large="large"
        >
          <v-icon> mdi-web </v-icon>
          <div style="position: absolute; bottom: 0px; background-color: white; font-size: smaller;">{{ current_lang }}</div>
        </v-btn>
      </template>

      <v-list dense>
        <v-list-item-group
          v-model="selected_lang"
        >
          <v-list-item
            v-for="[key,value] in languages"
            :key="key"
            @click="change_lang(key)"
          >
            {{ value }}
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  export default {
    name: 'LangSelect',

    components: {
    },

    props: {
      small: Boolean,
      large: Boolean
    },

    data: () => ({
      selected_lang: 0,
      current_lang: 'es',
    }),

    computed: {
      ...mapGetters(['user']),
      languages() {
        return  Object.entries(this.$vuetify.lang.locales).map(([key, value]) => ([key,value.lang])).toSorted();
      },
    },

    mounted() {
      // idioma usuario
      this.selected_lang = this.languages.findIndex(([id,name]) => id == this.user.lang);
    },

    methods: {
      change_lang(lang) {
        if (this.current_lang != lang) {
          this.selected_lang = this.languages.findIndex(([id,name]) => id == lang);
          this.current_lang = lang;
          this.$emit('update',lang);
          //this.$vuetify.lang.current = lang;
        }
      }
    },
  };
</script>